import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconTag = createIcon({
  displayName: 'IconTag',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M3 13.41L12.5 22.91L22.91 12.5L13.41 3H7V5H12.59L20.09 12.5L12.5 20.09L5 12.59V3H3V13.41ZM10 9C10 9.55228 9.55228 10 9 10C8.44772 10 8 9.55228 8 9C8 8.44772 8.44772 8 9 8C9.55228 8 10 8.44772 10 9Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
